import React, { FC } from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';
import Button from '@components/button';
import { SimpleOnPress } from '@interfaces/base';
import { WithColor } from '@styles/colors';

interface EmptyStatePromptProps extends WithColor, Partial<SimpleOnPress> {
  background?: string;
  text?: string;
  buttonText?: string;
  hideButton?: boolean;
}

const EmptyStatePrompt: FC<EmptyStatePromptProps> = ({
  onPress,
  background,
  C,
  text = 'Something went wrong',
  buttonText = 'Clear filters',
  hideButton = false,
}) => {
  const bg = background || C('Background / Light / System');
  return (
    <View style={[{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }, { backgroundColor: bg }]}>
      <View style={{ width: scale(68), height: scale(68), justifyContent: 'center', alignItems: 'center' }}>
        <Svg icon="search" color="Label/Light/Tertiary" width={45} height={45} />
      </View>
      <Text style={[font['Title 2'], { marginBottom: scale(28), marginTop: scale(4) }]}>{i18n.t(text)}</Text>
      {!hideButton && onPress && (
        <Button
          {...{
            variant: 'Dialog L',
            type: 'Primary',
            name: i18n.t(buttonText),
            bg: C('Button/Light/Primary'),
            width: scale(95),
            height: scale(53),
            borderRadius: scale(12),
            onPress,
          }}
        />
      )}
    </View>
  );
};

export default EmptyStatePrompt;
